// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__TTYAt","headerArea":"Sidebar_headerArea__mKuTI","itemsScroll":"Sidebar_itemsScroll__yTujV","sidebarSpin":"Sidebar_sidebarSpin__zaBRB"};